<template>
  <div id="app" :class="this.$route.name">
    <AppHeader />
    <transition name="slide" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>
<script>
// Components
import AppHeader from "@/components/AppHeader.vue";
//import AppFooter from "@/components/AppFooter.vue";

export default {
  name: "app",
  components: {
    AppHeader
  },
  computed: {},
  data: function() {
    return {};
  },
  created() {},
};
</script>
<style lang="scss">
@import "./src/css/style.scss";
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
